document.addEventListener("DOMContentLoaded", (event) => {

  gsap.registerPlugin(ScrollTrigger);

  const header = document.querySelector('.kk-header');
  const headerHeight = header.offsetHeight;

  // Create and expose Lenis instance globally
  window.lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
    smoothTouch: false,
    touchMultiplier: 0,
    infinite: false,
    autoResize: true,
  });

  function raf(time) {
    window.lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  if (document.querySelector('.hero-2')) {
    const link = document.querySelector('.link--underline');
    // Schweiz: der Hero-Knopf springt zur Kaufbox (siehe kk-ch-sticky-buy)
    if (link.getAttribute('href') === '#') link.addEventListener('click', (e) => {
      window.lenis.scrollTo('#features-2', { offset: 0, duration: 2 })
    });
  }

  // /* Splitting text */
  // animateText('.hero-2__title', 'letter'); // Change splitting technique here (by line, by word, by letter)
  const links = document.querySelectorAll('a[href^="#"]');

  links.forEach(link => {
    if (link.hasAttribute('data-kk-buy-jump')) return;
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - headerHeight;

        window.lenis.scrollTo(offsetPosition, {
          duration: 1.2, // Dauer des Scrollens in Sekunden
          easing: (t) => t * (2 - t), // Easing-Funktion
        });
      }
    });
  });
});

// (function () {
//   // console.log("kk - Init custom atc form submit handler");
//   var forms = document.querySelectorAll('.product-form');
//   if (forms.length === 0) {
//     return;
//   }

//   let url = window.location.href;
//   let searchParams = new URLSearchParams();

//   // Überprüfen, ob die URL einen Hashtag enthält
//   let hashIndex = url.indexOf('#');
//   if (hashIndex !== -1) {
//     // Wenn ein Hashtag vorhanden ist, extrahieren Sie den Teil nach dem Hashtag
//     let afterHash = url.substring(hashIndex + 1);

//     // Suchen Sie nach dem Fragezeichen nach dem Hashtag
//     let questionMarkIndex = afterHash.indexOf('?');
//     if (questionMarkIndex !== -1) {
//       // Wenn ein Fragezeichen gefunden wurde, extrahieren Sie die Parameter
//       let paramString = afterHash.substring(questionMarkIndex + 1);
//       searchParams = new URLSearchParams(paramString);
//     }
//   } else {
//     // Wenn kein Hashtag vorhanden ist, verwenden Sie die normale search-Eigenschaft
//     searchParams = new URLSearchParams(window.location.search);
//   }

//   forms.forEach(function (form) {
//     form.addEventListener('submit', function (event) {
//       event.preventDefault();
//       var id = form.querySelector('[name="id"]').value;
//       window.location.href = `https://${Shopify.shop}/cart/${id}:1?${searchParams}`;
//     });
//   });
// })();

(function () {
  const headerCartIcon = document.querySelector('#headerCartIcon');
  const headerCTAButton = document.querySelector('#headerCTAButton');
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function ({ cart }) {
    const { item_count } = cart;
    console.log('kk - item count: ', item_count);
    if (item_count > 0) {
      headerCartIcon && headerCartIcon.classList.add('show-cart-icon');
      if (headerCTAButton) headerCTAButton.classList.add('hide-header-cta');
    } else {
      headerCartIcon && headerCartIcon.classList.remove('show-cart-icon');
      if (headerCTAButton) headerCTAButton.classList.remove('hide-header-cta');
    }
  })
})();
